<template><div><h1>VUX V2.1.1Rc.14 released</h1>
<h2><a href="/en/components/checker.html">Checker</a></h2>
<ul><li>[enhance] Now disabled item also emits event:on-item-click #1144</li>
</ul>
<h2><a href="/en/components/form-preview.html">FormPreview</a></h2>
<ul><li>[fix] Fix variable: form-preview-button-primary-color</li>
<li>[feature] Support prop:name #1123</li>
</ul>
<h2><a href="/en/components/masker.html">Masker</a></h2>
<ul><li>[feature] Support prop:fullscreen</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[fix] fix can not set Selector name attrbiute bug #1133</li>
<li>[enhance] Selector value support Boolean. @rbao</li>
</ul>
<h2><a href="/en/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] Fix left-menu is shown when sliding back and forth #1139</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] Fix cannot set value to true initially #1138</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.14 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.14-80.vue?03ed2781